import { render, staticRenderFns } from "./NodeLightningNetworkDataTable.vue?vue&type=template&id=82ef0392&scoped=true&"
import script from "./NodeLightningNetworkDataTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./NodeLightningNetworkDataTable.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ef0392",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
